import React from "react";

import MarketBg from "../../assets/img/market/Group.png";
import NFTBg from "../../assets/img/market/NFT Data.png";

// import listBg from "../../assets/img/services/contract/list.png";
// import settingsSVG from "../../assets/img/services/contract/settings.svg";
// import rotateSVG from "../../assets/img/services/contract/rotate.svg";

function fullScale() {
  return (
    <div className="">
      <div>
        <div className="flex flex-col h-full items-center">
          <div className="flex flex-col lg:flex-row w-[80%] m-auto">
            <div className="w-full lg:w-1/2">
              <img
                src={MarketBg}
                alt=""
                className="m-auto lg:w-[100%] -mt-[5%] mb-10 lg:-ml-16"
              />
            </div>
            <div className="flex items-center justify-center md:w-[100%]">
              <div className="block">
                {/* <div className="sm:px-12">
                  <div className="text-[14px] lg:text-[24px] text-white sm:text-left md:text-left uppercase mb-5">
                    Full-Scale Marketplace
                  </div>
                  <div>
                    <p className=" text-white sm:text-left md:text-left break-words lg:w-[100%] mb-5 text-xs md:text-lg">
                      On the surface, it may seem like marketplaces are much
                      more complex than other, similar businesses, due to their
                      nature as multi-vendor platforms. The truth is the
                      marketplace model is surprisingly lean and scalable for
                      new startups.
                    </p>
                  </div>
                </div> */}
                <div className="text-[18px] lg:text-[24px] font-bold text-white sm:text-left md:text-left uppercase mb-5 sm:pl-8">
                  Full-Scale Marketplace
                </div>
                <div>
                  <p className=" text-white sm:text-[14px] sm:text-left md:text-left break-words lg:w-[100%] mb-5 text-xs md:text-lg sm:px-8">
                    On the surface, it may seem like marketplaces are much more
                    complex than other, similar businesses, due to their nature
                    as multi-vendor platforms. The truth is the marketplace
                    model is surprisingly lean and scalable for new startups.
                  </p>
                  <div className="flex flex-row">
                    <div className="w-full md:w-1/2 mr-4 sm:pl-8">
                      <img src={NFTBg} alt="list" className="w-full" />
                    </div>
                    {/* <div className="w-1/2 hidden md:block">
                      <div className="flex flex-col gap-5">
                        <div>
                          <img src={settingsSVG} alt="list" width={70} />
                        </div>
                        <div>
                          <img src={rotateSVG} alt="list" width={50} />
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="fixed sm:top-28 -bottom-[17%] lg:-bottom-[16%] 2xl:-bottom-[15%] font-bold text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] sm:-left-20 lg:-left-10 2xl:left-10 md:scale-[0.83] 2xl:scale-[0.95] sm:scale-[0.5] h2Mobile md:block hidden">
          MARKETPLACE
        </h2>
      </div>
    </div>
  );
}

export default fullScale;
